import { createAction } from 'redux-actions'
import * as types from '../constants/UserAccountConstant'

export const deleteUserAccount = createAction(types.DELETE_USER_ACCOUNT)
export const deleteUserAccountInit = createAction(types.DELETE_USER_ACCOUNT_INIT)
export const deleteUserAccountSuccess = createAction(types.DELETE_USER_ACCOUNT_SUCCESS)
export const deleteUserAccountFail = createAction(types.DELETE_USER_ACCOUNT_FAIL)
